import { render, staticRenderFns } from "./close.vue?vue&type=template&id=84c06756&scoped=true&"
var script = {}
import style0 from "./close.vue?vue&type=style&index=0&id=84c06756&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c06756",
  null
  
)

export default component.exports